import React from 'react';
// Import from './context' directly, not the barrel — avoids an import cycle.
// See .claude/context/journeys.md.
import { useJourney } from './context';
import { createLazyComponent } from '../shared/createLazyComponent';
import { DrawerLoading } from '../shell/DrawerLoading';

// Cached per descriptor (not built during render). See .claude/context/journeys.md for
// why it's a WeakMap keyed on the descriptor, and the warm-chunk reason it's a loader.
const lazyContentByDescriptor = new WeakMap();
const getLazyContent = (descriptor) => {
  if (!lazyContentByDescriptor.has(descriptor)) {
    lazyContentByDescriptor.set(descriptor, createLazyComponent(
      descriptor.load,
      descriptor.exportName,
      { label: descriptor.label ?? 'Journey content', placeholder: <DrawerLoading /> },
    ));
  }
  return lazyContentByDescriptor.get(descriptor);
};

// The Shell's body slot — renders the active journey's content, lazily.
// See .claude/context/journeys.md.
export const JourneyContent = () => {
  const journey = useJourney();
  const content = journey?.content;
  if (!content) return null;
  const LazyJourneyContent = getLazyContent(content);
  return <LazyJourneyContent />;
};
